import TableData from "./TableData";;
import ListData from "./ListData";

const quickSharesComponents = {
  TableData,
  ListData,
}

export default quickSharesComponents;